export function CardHeader({ title }: { title: string }) {
    return (
      <div className="bg-gray-50 py-2 text-center border border-gray-100">
        <div className="inline-block text-xl px-4 text-slate opacity-50 rounded font-medium">
          {title}
        </div>
      </div>
    );
  }